import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DisplayComparedField } from '../../services/dead-letter-compare.service';

@Component({
    selector: 'app-dead-letter-treatment-group-section',
    templateUrl: './dead-letter-treatment-group-section.component.html',
    styleUrls: ['./dead-letter-treatment-group-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeadLetterTreatmentGroupSectionComponent {
  @Input() treatmentGroupCompare: Record<string, DisplayComparedField> = {};
  @Input() expanded = false;
  @Input() showChangeIndicator = false;
  @Output() expandedChange = new EventEmitter<boolean>();
}
